import React from "react";
import {
  createStyles,
  withStyles,
  WithStyles,
  StyleRules
} from "@material-ui/core/styles";
import ErrorIcon from "@material-ui/icons/Error";
import KnowbeButton from "@components/presentational/atoms/KnowbeButton";
import { GetFacilityUsersResponse } from "@api/requests/facility/getFacilityUsers";
import { ErrorsState } from "@stores/domain/errors/types";

const styles = (): StyleRules =>
  createStyles({
    li: {
      display: "flex",
      alignItems: "center",
      padding: "14px 16px",
      "&:nth-child(2n)": {
        backgroundColor: "#f5f5f5"
      }
    },
    userName: {
      margin: "0 auto 0 0",
      color: "rgba(0, 0, 0, 0.87)"
    },
    alertPeriod: {
      position: "relative"
    },
    alertIcon: {
      width: 14,
      height: 14,
      color: "#ff5656",
      position: "absolute",
      zIndex: 1,
      top: -7,
      right: -4
    },
    recordButton: {
      marginLeft: 8
    }
  });

type OwnProps = {
  user: GetFacilityUsersResponse["data"][0];
  errorState: ErrorsState["records"]["data"];
};

type Props = OwnProps & WithStyles<typeof styles>;

const RecordEachUserSupportOnlyCore = (props: Props): JSX.Element => {
  const { classes, user } = props;
  return (
    <li className={classes.li}>
      <div className={classes.userName}>{user.displayName}</div>
      <div className={classes.alertPeriod}>
        {props.errorState &&
          props.errorState.length > 0 &&
          props.errorState[0].errors.map((error) => {
            if (error.relation.value === user.uif_id) {
              return (
                <ErrorIcon
                  className={classes.alertIcon}
                  key={error.relation.key}
                />
              );
            }
            return null;
          })}
        <KnowbeButton
          kind="outlineWhite"
          className={classes.recordButton}
          href={`#/record/${user.uif_id}/support_plan`}
        >
          個別支援計画
        </KnowbeButton>
      </div>
      <KnowbeButton
        kind="outlineWhite"
        className={classes.recordButton}
        href={`#/record/${user.uif_id}/support`}
      >
        支援記録
      </KnowbeButton>
    </li>
  );
};

export const RecordEachUserSupportOnly = withStyles(styles)(
  RecordEachUserSupportOnlyCore
);
